import React, { useState } from "react";
import { Box, Typography, Switch, TextField, FormControlLabel, MenuItem, Select, InputLabel, FormControl } from "@mui/material";
import BaseButton from "../../UI/BaseButton/BaseButton";
import CustomAlert from "../../UI/CustomAlert/CustomAlert";
import PinPad from "../../PinPad/PinPad";
import { changeUsername, changeUsernameVerifyCode } from "../../../util/API/admin";
import { useSelector } from "react-redux";
import { countries, countryAreaCode } from "../../../constants/countrylist";
import {  } from "../../../util/API/admin";
import { getTableData } from "../../../util/API/tableServices";

const UsernameReset = ({
    selectedUserData,
    updateTableStatus,
    handleClose
}) => {
  // console.log("countryAreaCode===========",countryAreaCode);
  console.log("countries===========",countries);
    //   const [isEmail, setIsEmail] = useState(true);
    const [newUsername, setNewUsername] = useState("")
    const [verificationSent, setVerificationSent] = useState(false);
    const [verificationCode, setVerificationCode] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [showPinPad, setShowPinPad] = useState(false);
    const [selectedAreaCode, setSelectedAreaCode] = useState("");
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [alert, setAlert] = useState(
        {
          showAlert: false,
          severity: "error",
          header: "",
          message: "",
          isUpdated: false
        }
      );
    const [isEmail, setIsEmail] = useState(true);

    let pin = sessionStorage.getItem("pin");
    let agent = JSON.parse(sessionStorage.getItem("user")).payload?.body;
    const pinConfiguration = useSelector((state) => state.login.pinConfiguration);

    console.log(selectedUserData)

    console.log(agent)

  const handleSwitchChange = (event) => {
    // setIsEmail(event.target.checked);
    const isEmailSelected = event.target.checked;
    setIsEmail(isEmailSelected);
    if (isEmailSelected) {
      setSelectedAreaCode(""); // reset on email switch
    }
  };

// const handleConfirm = (event, pin) => {
//   let PIN = pin.join('');
//   sendVerificationCodeWithPin(event, PIN);
//   setShowPinPad(false);
// };

const handleConfirm = (event, pin) => {
  let PIN = pin.join('');
  if(verificationCode!== "" && verificationCode.length>0) {
    handleSubmit(event, PIN)
  } else {
    sendVerificationCodeWithPin(PIN);
  }
  setShowPinPad(false);
};

const sendVerificationCodeWithPin = async () => {
  // let countrycode = countries.find((country) => country.flag === selectedUserData?.User?.countryid)?.areaCode;
  const selected = countries.find(c => c.flag === selectedUserData?.User?.countryid);

  let countrycode = isEmail
    ? selected?.areaCode
    : selectedCountry?.areaCode;

  let countryFlag = isEmail
    ? selected?.flag
    : selectedCountry?.flag;

  try {
    setIsLoading(true);

    console.log("Data to send------------", selectedUserData?.Useremailaccount?.emailAccount,
    1234,
    selectedUserData?.User?.id,
    newUsername,
    agent['User']?.id,
    countrycode,
    isEmail ? "email" : "mobile",
    agent['Useremailaccount']?.emailAccount,
    countryFlag);

    const response = await changeUsername(
      selectedUserData?.Useremailaccount?.emailAccount,
      1234,
      selectedUserData?.User?.id,
      newUsername,
      agent['User']?.id,
      countrycode,
      isEmail ? "email" : "mobile",
      agent['Useremailaccount']?.emailAccount,
      countryFlag
    );

    if (response?.callStatus === "1") {
      setVerificationSent(true);
      setAlert({
        showAlert: true,
        severity: "success",
        message: "Verification code sent successfully",
        header: "Success"
      });
    } else {
      setAlert({
        showAlert: true,
        severity: "error",
        message: response?.payload?.msg || "Failed to send verification",
        header: "Error"
      });
    }
  } catch (err) {
    setAlert({
      showAlert: true,
      severity: "error",
      message: "An error occurred while sending verification",
      header: "Error"
    });
  } finally {
    setIsLoading(false);
  }
};

  const handleSubmit = async(event, pin) => {

    // let countrycode = countries.filter((country) => country.flag === selectedUserData?.User?.countryid)[0]?.areaCode
    const selected = countries.find(c => c.flag === selectedUserData?.User?.telephonenocountrycode);

    let countrycode = isEmail
      ? selected?.areaCode
      : selectedCountry?.areaCode;

    let countryFlag = isEmail
      ? selected?.flag
      : selectedCountry?.flag;

    console.log("selectedUserData=============",selectedUserData)
    console.log("selectedUserData=============",selectedUserData?.User?.telephonenocountrycode)
    console.log("countrycode=============",countrycode)
    console.log("deviceID=============",localStorage.getItem("deviceID"))

    const selectedCode = countries.find(c => c.flag === selectedUserData?.User?.telephonenocountrycode);
    const areaCodeWithoutPlus = selectedCode?.areaCode?.replace(/^\+/, '');
    console.log("areaCodeWithoutPlus=============",areaCodeWithoutPlus)

    try {
        setIsLoading(true);
        const response = await changeUsernameVerifyCode(
            selectedUserData?.Useremailaccount?.emailAccount,
            pin,
            selectedUserData?.User?.id,
            newUsername,
            agent['User']?.id,
            countrycode,
            isEmail ? "email" : "mobile",
            agent['Useremailaccount']?.emailAccount,
            verificationCode,
            countryFlag,
            localStorage.getItem("deviceID"),
            selectedUserData?.User?.telephoneno
            // `${areaCodeWithoutPlus}${selectedUserData?.User?.telephoneno}`
        )
    
        if (response?.callStatus === "1") {
            setAlert({
                header: "Success",
                message: "Username reset successfully",
                severity: "success",
                showAlert: true,
                isUpdated: true
            })

            setNewUsername("");
            setVerificationSent(false);
            setVerificationCode("");
            updateTableStatus();
        } else if(response?.callStatus == "2") {
          setAlert({
            header: "Error",
            message: response?.msg,
            severity: "error",
            showAlert: true
          })
          // setNewUsername("");
          // setVerificationSent(false);
          setVerificationCode("");
        } else {
            setAlert({
                header: "Error",
                message: response?.payload?.msg,
                severity: "error",
                showAlert: true
            })
            // setNewUsername("");
            // setVerificationSent(false);
            setVerificationCode("");
        }
    }
    catch (error) {
        console.log(error)
    } finally {
      setIsLoading(false);
    }
  };

  // const handleSubmitClick = () => {
  //   // Email validation regex
  //   const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  
  //   if (!newUsername) {
  //     setAlert({
  //       showAlert: true,
  //       severity: "error",
  //       message: "Please enter a username",
  //       header: "Error!"
  //     });
  //     return;
  //   }
  
  //   if (isEmail && !emailRegex.test(newUsername)) {
  //     setAlert({
  //       showAlert: true,
  //       severity: "error",
  //       message: "Please enter a valid email address",
  //       header: "Error!"
  //     });
  //     return;
  //   }
  
  //   // If valid, show the PinPad
  //   setShowPinPad(true);
  // };

  const handleSubmitClick = () => {
    if (!verificationCode) {
      return setAlert({
        showAlert: true,
        severity: "error",
        message: "Please enter the verification code",
        header: "Error!"
      });
    }

    // Proceed to show PinPad
    setShowPinPad(true);
  };

  const handleSendVerification = async() => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  
    if (!newUsername) {
      return setAlert({
        showAlert: true,
        severity: "error",
        message: "Please enter a username",
        header: "Error!"
      });
    }
  
    if (isEmail && !emailRegex.test(newUsername)) {
      return setAlert({
        showAlert: true,
        severity: "error",
        message: "Please enter a valid email address",
        header: "Error!"
      });
    }
  
    // Show PinPad instead of calling API directly
    // setShowPinPad(true);
    await sendVerificationCodeWithPin();
  };
  

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f5f5f5",
        padding: "16px",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#ffffff",
          borderRadius: "8px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          width: "500px",
          padding: "24px",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h6"
          sx={{ marginBottom: "16px", color: "#333333", fontWeight: "bold" }}
        >
          Username Reset
        </Typography>

        <Box >
          Current Username: {selectedUserData?.Useremailaccount?.emailAccount}
        </Box>

        <FormControlLabel
          control={
            <Switch
              checked={isEmail}
              onChange={handleSwitchChange}
              color="primary"
            />
          }
          label={isEmail ? "Email" : "Mobile"}
          sx={{ justifyContent: "center" }}
          disabled={verificationSent == true ? true : false}
        />
        {/* <Box sx={{marginBottom: "24px"}}>
          Current Username: {selectedUserData?.Useremailaccount?.emailAccount}
        </Box> */}
        {!isEmail && (
          <FormControl fullWidth sx={{ marginBottom: "16px" }}>
            <InputLabel id="area-code-label">Select Area Code</InputLabel>
            <Select
              labelId="area-code-label"
              disabled={verificationSent == true ? true : false}
              // value={selectedAreaCode}
              // value={selectedCountry?.areaCode || ""}
              value={selectedCountry?.flag || ""}
              label="Select Area Code"
              // onChange={(e) => setSelectedAreaCode(e.target.value)}
              // onChange={(e) => {
              //   const country = countries.find(c => c.areaCode === e.target.value);
              //   setSelectedCountry(country);
              // }}
              onChange={(e) => {
                console.log("e.target.value===========",e.target.value);
                const country = countries.find(c => c.flag === e.target.value);
                setSelectedCountry(country);
              }}
            >
              {countries.map((country, idx) => (
                <MenuItem key={idx} value={country.flag}>
                  {country.country} ({country.areaCode})
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        <TextField
          label={isEmail ? "Enter new username" : "Enter new mobile number only"}
          variant="outlined"
          fullWidth
          sx={{ marginBottom: "24px" }}
          value={newUsername}
          disabled={verificationSent == true ? true : false}
          onChange={(e) => setNewUsername(e.target.value)}
        />
        {/* <BaseButton
          buttonText="Submit"
          onClick={(e) => pin ? handleSubmit(e, pin) : pinConfiguration === "never" ? handleSubmit(e, '0000') : handleSubmitClick()}
          /> */}

        {!verificationSent ? (
          <BaseButton
            buttonText={isLoading ? "Sending..." : "Send Verification Code"}
            disabled={isLoading}
            onClick={handleSendVerification}
          />
        ) : (
          <>
            <TextField
              label="Enter Verification Code"
              variant="outlined"
              fullWidth
              sx={{ marginBottom: "16px" }}
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value)}
            />
            <BaseButton
              buttonText={isLoading ? "Submitting..." : "Submit"}
              disabled={isLoading}
              onClick={(e) =>
                pin
                  ? handleSubmit(e, pin)
                  : pinConfiguration === "never"
                  ? handleSubmit(e, "0000")
                  : handleSubmitClick()
              }
            />
          </>
        )}
      </Box>
      <CustomAlert 
        severity={alert.severity} 
        show={alert.showAlert} 
        header={alert.header} 
        message={alert.message} 
        onClick={(prev) => {
          if (alert.severity === "success" && alert?.isUpdated === true) {
            handleClose();
          }
          setAlert({...prev, showAlert: false})
        }}
        autoclose={alert.severity === "error" ? false : true}
      />
      {showPinPad && 
        <PinPad 
          show={showPinPad} 
          handleConfirm={handleConfirm} 
          onClick={() => setShowPinPad(false)} 
        />
      }
    </Box>
  );
};

export default UsernameReset;
